export default __webpack_public_path__ + "static/media/expoindo-1.2201cded.jpg";